import apiClient from "@/api/index";
import router from "@/router";

export const reportFastSetsModule = {
    namespaced: true,

    state: () => ({
        reportData: {},
        reportLoading: true,
        filterset: {},
        filtersetLoading: true,
        filterSpecs: {},
        excelData: {},
    }),

    mutations: {
        setReportData(state, data) {
            state.reportData = data;
            state.reportLoading = false;
        },

                setReportFilterset(state, data) {
            state.filterSpecs['shop'] = []
            state.filterSpecs['date_range'] = []

            if(Object.keys(router.currentRoute.value.query).length == 0) {
                for(let filter in data) {
                    if(filter !== 'title') {
                        for(let i = 0; i < data[filter].choices.length; i++) {
                            if(filter === 'date_range') {
                                state.filterSpecs[filter].push(data[filter].choices[i].value)
                            } else {
                                if(data[filter].multi_choices) {
                                    if(data[filter].choices[i].checked) {
                                        state.filterSpecs[filter].push(data[filter].choices[i].value)
                                    }
                                } else {
                                    if(data[filter].choices[i].checked) {
                                        state.filterSpecs[filter] = data[filter].choices[i].value
                                    }
                                }
                                
                            }
                        }
                    }
                }
            } else {
                const queries = router.currentRoute.value.query

                state.filterSpecs['shop'] = []
                state.filterSpecs['time_range'] = []

                if(queries.shop) {
                    console.log(queries.shop);
                    if(Array.isArray(queries.shop)) {
                        state.filterSpecs['shop'] = queries.shop
                    } else {
                        state.filterSpecs['shop'] = [Number(queries.shop)]
                    }
                }

                queries.date_from ? state.filterSpecs['date_range'].push(queries.date_from) : state.filterSpecs['date_range'].push('')
                queries.date_to ? state.filterSpecs['date_range'].push(queries.date_to) : state.filterSpecs['date_range'].push('')
            }
            
            state.filterset = data
            state.filtersetLoading = false
        },

        setExcelData(state, data) {
            state.excelData = data;
        },

        sortReportData(state, { id, asc }) {
            const array = state.reportData.rows
            // Удаляем из массива последний и первый элемент, объявляем их в переменную
            // чтобы не учитывать в сортировке
            const firstRow = array.shift()
            const lastRow = array.pop() 

            array.sort((a, b) => {
                const valueA = a.find(item => item.id === id).value;
                const valueB = b.find(item => item.id === id).value;

                let comparison = 0;
                if (typeof valueA === 'string' && typeof valueB === 'string') {
                    comparison = valueA.localeCompare(valueB);
                } else {
                    comparison = valueA - valueB;
                }
                
                const data = asc ? comparison : -comparison
                return data;
            });

            // Возвращаем обратно строки
            array.unshift(firstRow)
            array.push(lastRow)
        }
    },

    actions: {
        async getReportData({ commit, state }) {
            state.reportLoading = true;
            // Проверяет, есть ли параметры которые можно передать в запросе
            if (router.currentRoute.value.fullPath.split("?")[1]) {
                try {
                    const response = await apiClient.get(
                        "/reports/fast_sets/data?" +
                            router.currentRoute.value.fullPath.split("?")[1],
                        {
                            headers: {
                                Authorization: "Token " + localStorage.getItem("token"),
                            },
                        }
                    );
                    commit("setReportData", response.data.data);
                    commit("setExcelData", response.data);
                } catch (err) {
                    // Если есть ошибка
                    alert(err);
                }
                // Если нет, делать запрос без параметров
            } else {
                try {
                    const response = await apiClient.get("/reports/fast_sets/data", {
                        headers: {
                            Authorization: "Token " + localStorage.getItem("token"),
                        },
                    });
                    commit("setReportData", response.data.data);
                    commit("setExcelData", response.data);
                } catch (err) {
                    // Если есть ошибка
                    alert(err);
                }
            }
        },

        async getReportFilterset({ commit }) {
            try {
                const response = await apiClient.get("/reports/fast_sets/filterset", {
                    headers: {
                        Authorization: "Token " + localStorage.getItem("token"),
                    },
                });
                commit("setReportFilterset", response.data);
            } catch (err) {
                // Если есть ошибка
                console.log(err)
            }
        },

        async getExcelFile({ state }) {
            try {
                const response = await apiClient.post(
                    "/reports/export_to_excel/",
                    state.excelData,
                    {
                        headers: {
                            Authorization: "Token " + localStorage.getItem("token"),
                        },
                        responseType: "blob",
                    }
                );
                const now = new Date();
                const url = URL.createObjectURL(response.data);
                const a = document.createElement("a");
                a.href = url;
                a.download = `${state.excelData.title}_${now.toLocaleDateString()}.xls`;
                a.style.display = "none";
                document.body.appendChild(a);
                a.click();
                a.remove();
                URL.revokeObjectURL(url);
            } catch (err) {
                // Если есть ошибка
                alert(err);
            }
        },
    },
};
